import { types } from 'mobx-state-tree';
import EntityType from './EntityType';

const EntityTypes = types.model('EntityTypes', {
  entityTypes: types.array(EntityType),
  gcpEntityTypes: types.array(types.string),
});

export default EntityTypes;
